import { Component, OnInit, Input } from '@angular/core';

// services
import { MasterService } from '../../services/master.service'
import { MessageService } from '../../services/message.service';
import { StoreService } from '../../services/store.service';
import * as languageLibrary from '../../services/language'
@Component({
    selector: 'app-profile-dashboard',
    templateUrl: './profile-dashboard.component.html',
    styleUrls: ['./profile-dashboard.component.scss'],
    standalone: false
})

export class ProfileDashboardComponent implements OnInit {
    // save the language
    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'

    // set all words
    protected words = languageLibrary.language

    // define if sector is account settings or customer information (default is customer information)
    protected section = 1

    // display de loading state
    protected loading: boolean = true

    // user information
    protected userInformation: any = {}

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService) { }

    ngOnInit() {
        if (!this.store.userAccount['user']) {
            return
        }

        this.loading = true
        this.userInformation = { ...this.store.userAccount['user'] }
        this.loading = false
    }

    // todo: listen to output of navbar
    protected listenerNav = (e): void => {
        switch (e['message']) {
            case 'changeLanguage':
                this.language = e['value']
                break;
            case 'getUserAccount':
                // permissions on user list
                this.loading = false
                this.userInformation = { ...e.data }
                break;
            default:
                break;
        }
    }
}
